import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { DartsGameScore, DartsMatchType, EventScoreboard, ScoreboardType, SetGameScore } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { DartsLegsPeriodInfo, DartsSetsAndLegsPeriodInfo } from '@frontend/sports/common/core/data-access/constants';

@Component({
    selector: 'ms-best-of',
    template: '{{bestOfInfo}}',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BestOfComponent implements OnChanges {
    @Input() scoreboard: EventScoreboard;
    @Input() excludeSeparator = false;
    bestOfInfo: string;

    constructor(private sitecore: Sitecore) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.bestOfInfo = '';
        if (this.scoreboard.started) {
            this.bestOfInfo = this.getBestOf();
        }
    }

    get separator(): string {
        return this.excludeSeparator ? '' : ' - ';
    }

    private getBestOf(): string {
        let time = '';

        if (this.isType(ScoreboardType.Darts)) {
            time = this.getDartsTime();
        }
        if (this.isType(ScoreboardType.Snooker)) {
            time = this.getSnookerTime();
        }

        if (this.isType(ScoreboardType.SetGame)) {
            const score = this.scoreboard.score as SetGameScore;
            if (score.gameMode) {
                time = `${score.gameMode} - `;
            }
        }

        return time;
    }

    private getDartsTime(): string {
        const currperiodArr = this.scoreboard.period!.name.split(' ', 2);
        const currentPeriodId = currperiodArr[1];
        const scoreNewDarts = this.scoreboard.getScore<DartsGameScore>()!;
        if (
            (this.scoreboard.period!.id === DartsLegsPeriodInfo.Finished && scoreNewDarts.matchType === DartsMatchType.LegOnly) ||
            (this.scoreboard.period!.id === DartsSetsAndLegsPeriodInfo.Finished && scoreNewDarts.matchType === DartsMatchType.SetsAndLegs)
        ) {
            return '';
        }

        if (scoreNewDarts.matchType === DartsMatchType.LegOnly && this.scoreboard.bestOfLegs) {
            return `${this.sitecore.globalMessages.BestOf} ${this.scoreboard.bestOfLegs}${this.separator}`;
        } else if (scoreNewDarts.matchType === DartsMatchType.SetsAndLegs && this.scoreboard.bestOfSets) {
            return `${this.sitecore.globalMessages.BestOf} ${this.scoreboard.bestOfSets}${this.separator}`;
        }

        return `${this.sitecore.globalMessages.BestOf} ${currentPeriodId}${this.separator}`;
    }

    private getSnookerTime(): string {
        return this.scoreboard.bestOf ? `${this.sitecore.globalMessages.BestOf} ${this.scoreboard.bestOf}` : '';
    }

    private isType(...types: ScoreboardType[]): boolean {
        return types.some((type) => this.scoreboard.type === type);
    }
}
